import type { WizardTileConfig } from '../../types/tileConfig';

const POWER_TYPE_TILE_CONFIGS: WizardTileConfig[] = [
  {
    label: 'offerWizard.stepPowerType.gruenstrom',
    value: 'gruenstrom',
    iconComponent: 'GruenstromIcon',
    urlValue: 'Gruenstrom',
  },
  {
    label: 'offerWizard.stepPowerType.graustrom',
    value: 'graustrom',
    iconComponent: 'GraustromIcon',
    urlValue: 'Graustrom',
  },
];

export default POWER_TYPE_TILE_CONFIGS;
